var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 427,
    height: 427,
    viewBox: "0 0 427 427",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2625_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.333 10.4414L279.249 144.017L426.667 165.436L320 269.41L345.173 416.226L213.333 346.91L81.485 416.226L106.667 269.41L0 165.436L147.409 144.017L213.333 10.4414Z",
    fill: "#299400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2625_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 426.667,
    height: 426.667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.3c80d76284bf1685eed4a67c8f9380b3.svg";
export { ForwardRef as ReactComponent };